module.exports = __webpack_public_path__ + "assets/b1d1776d8a95c64a807c3b12840828aa.png";